module.exports = __webpack_public_path__ + "static/media/cult-back-vid.bdb05362.mp4";